import { serverCall } from "utils/serverCall";
import {
  initMachineListRequest,
  setMachineList,
  errorMachineList,
  addMachine,
  updateMachine,
  setMachine,
  errorMachine,
  deleteMachine,
  setMachineListByCompanyId,
} from "./action";
import apiEndpoints from "utils/apiList";
import toast from "react-hot-toast";

export const fetchMachineList = ({
  searchQuery = null,
  currentPage = null,
  rowsPerPage = null,
} = {}) => {
  return async (dispatch) => {
    dispatch(initMachineListRequest());
    const params = new URLSearchParams();
    if (searchQuery !== null) params.append("name", searchQuery);
    if (currentPage !== null) params.append("page", currentPage);
    if (rowsPerPage !== null) params.append("limit", rowsPerPage);

    console.log(`params:${params}`);
    try {
      const result = await serverCall(
        `${apiEndpoints.MACHINE_LIST}/?${params.toString()}`,
        "GET",
        dispatch
      );
      if (result.success) {
        dispatch(setMachineList(result?.data?.payload));
      } else {
        dispatch(errorMachine(result.message));
      }
    } catch (error) {
      dispatch(errorMachine(error.message));
    }
  };
};

export const createMachine = (machineData, toggleModal) => {
  return async (dispatch) => {
    dispatch(initMachineListRequest());
    try {
      const result = await serverCall(
        apiEndpoints.MACHINE_CREATE,
        "POST",
        dispatch,
        machineData
      );
      if (result.success) {
        dispatch(addMachine(result?.data?.payload?.newMachine));
        dispatch(fetchMachineList());
        toggleModal();
        toast.success("Machine created successfully");
        // return Promise.resolve();
      } else {
        console.log(result);
        toast.error(result.message?.name || result.message);
        dispatch(errorMachine(result.message?.name || result.message));
      }
    } catch (error) {
      toast.error(error.message);
      dispatch(errorMachine(error.message));
      // return Promise.reject(error);
    }
  };
};

export const fetchMachineById = (machineId, stateToManage) => {
  return async (dispatch) => {
    dispatch(initMachineListRequest());
    try {
      const result = await serverCall(
        `${apiEndpoints.MACHINE_BYID}/${machineId}`,
        "GET",
        dispatch
      );
      if (result.success) {
        dispatch(setMachine(result?.data?.payload));
        stateToManage((prevState) => !prevState);
      } else {
        dispatch(errorMachine(result.message));
      }
    } catch (error) {
      dispatch(errorMachine(error.message));
    }
  };
};

export const fetchMachineListByCompanyId = (companyId) => {
  return async (dispatch) => {
    dispatch(initMachineListRequest());
    try {
      const result = await serverCall(
        `${apiEndpoints.MACHINE_LIST_BY_COMPANY}/${companyId}`,
        "GET",
        dispatch
      );
      if (result.success) {
        dispatch(setMachineListByCompanyId(result?.data?.payload));
      } else {
        dispatch(errorMachineList(result.message));
      }
    } catch (error) {
      dispatch(errorMachineList(error.message));
    }
  };
};

export const updateMachineById = (machineData, toggleModal, searchQuery, currentPage, rowsPerPage) => {
  return async (dispatch) => {
    dispatch(initMachineListRequest());
    try {
      const result = await serverCall(
        apiEndpoints.MACHINE_UPDATE,
        "POST",
        dispatch,
        machineData
      );
      if (result.success) {
        dispatch(fetchMachineList({ searchQuery, currentPage, rowsPerPage }));
        dispatch(updateMachine(result?.data?.payload?.updatedMachine));
        toggleModal();
        toast.success("Machine updated successfully");
      } else {
        toast.error(result.message);
        dispatch(errorMachine(result.message));
      }
    } catch (error) {
      toast.error(error.message);
      dispatch(errorMachine(error.message));
    }
  };
};

export const deleteMachineById = (payload, toggleModal) => {
  return async (dispatch) => {
    dispatch(initMachineListRequest());
    try {
      const { id: machineId, currentPage, rowsPerPage } = payload;
      const result = await serverCall(
        `${apiEndpoints.MACHINE_DELETE}/${machineId}`,
        "DELETE",
        dispatch
      );

      if (result.success) {
        dispatch(deleteMachine(machineId));
        dispatch(
          fetchMachineList({ searchQuery: "", currentPage, rowsPerPage })
        );
        toast.success(result.message || "Machine deleted successfully");
        toggleModal();
      } else {
        toast.error(result.message);
        dispatch(errorMachine(result.message));
      }
    } catch (error) {
      toast.error(error.message);
      dispatch(errorMachine(error.message));
    }
  };
};
